const ActionTypes = {
  SHOW_CONTACT: 'SHOW_CONTACT',
  HIDE_CONTACT: 'HIDE_CONTACT',
  SEND_CONTACT: 'SEND_MESSAGE',
  RESET_CONTACT: 'RESET_MESSAGE',

  SHOW_MESSAGE: 'SHOW_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  HIDE_MESSAGE: 'HIDE_MESSAGE',

  SHOW_MODAL: 'SHOW_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',

  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',

  SET_USAGE_TIMESTAMP: 'USETIME',
  RENEW_TOKEN: 'RENEWTOKEN',
};

export default ActionTypes;
